import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  FormControl,
  FormLabel,
  InputAdornment,
  Divider,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SoapObjective, SoapVitals, SoapPhysicalExam } from '../../types/soap';

interface ObjectiveSectionProps {
  data: SoapObjective;
  onChange: (data: SoapObjective) => void;
  disabled?: boolean;
}

const ObjectiveSection: React.FC<ObjectiveSectionProps> = ({
  data,
  onChange,
  disabled = false,
}) => {
  const handleAISummaryChange = (value: string) => {
    onChange({
      ...data,
      aiSummary: value,
    });
  };

  return (
    <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormControl fullWidth>
          <FormLabel sx={{ mb: 0.5, fontSize: '0.875rem', fontWeight: 'bold' }}>
            Objective Findings
          </FormLabel>
          <TextField
            multiline
            rows={10}
            fullWidth
            value={data.aiSummary || ''}
            onChange={(e) => handleAISummaryChange(e.target.value)}
            disabled={disabled}
            placeholder="Enter objective findings here"
            variant="outlined"
            sx={{
              '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                lineHeight: 1.6,
              },
            }}
          />
        </FormControl>
      </Box>
    </Paper>
  );
};

export default ObjectiveSection;
